module.exports = __webpack_public_path__ + "img/6_47.296e8194.png";